export const USE_ASSIGNMENT_DETAILS_QUERY_KEY = 'assignmentDetails';
export const ASSIGNMENT_DETAILS_CONTEXT_ERROR_MESSAGE =
  'AssignmentDetailsContext must be used inside AssignmentDetailsContext Provider scope';
